const SvgFileSearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M11.667 9.167h-5M8.334 12.5H6.667m6.667-6.667H6.667m10 2.917V5.667c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 00-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H7.334c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093c-.272.535-.272 1.235-.272 2.635v8.666c0 1.4 0 2.1.272 2.635A2.5 2.5 0 004.7 18.061c.535.272 1.235.272 2.635.272h2.25m8.75 0l-1.25-1.25M17.917 15a2.917 2.917 0 11-5.833 0 2.917 2.917 0 015.833 0z"
    ></path>
  </svg>
)

export default SvgFileSearchIcon
